import axios from "axios";

export default axios.create({
    baseURL:"https://api-pay.pitech.ae/user"
    // baseURL:"http://69.62.83.82:4040/user"
})
